import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodePartner as Type } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface PartnerProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

interface LogoProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  logo?: string;
  title: string;
}

const Logo: React.FC<LogoProps> = ({ logo, title }) => (
  <>
    {logo && (
      <div className="NodePartner__logo">
        <Image src={logo} alt={title} />
      </div>
    )}
    <div className="NodePartner__content">
      <p className="NodePartner__title">{title}</p>
    </div>
  </>
);

const NodePartner: React.FC<PartnerProps> = ({ entity, className }) => {
  const classes = classNames(className, 'NodePartner');
  const partner = entity.toJS();
  const title = partner.title[0].value;
  // #TODO: Add a responsive image component once ready
  const logo = partner.field_media_item[0]?.styles?.original;
  const link = partner.field_link[0];
  const linkUrl = link?.alias || link?.uri;
  const linkTitle = link?.title;
  const email = partner.field_email_address[0]?.value;
  const telephone = partner.field_telephone[0]?.value;

  return (
    <div className={classes}>
      {linkUrl ? (
        <CoreLink to={linkUrl}>
          <Logo
            logo={logo}
            title={title}
          />
        </CoreLink>
      ) : (
        <Logo
          logo={logo}
          title={title}
        />
      )}

      {email && (
        <div className="NodePartner__email">
          <CoreLink to={`mailto:${email}`}>
            <i className="icon icon-arrow" />
            {email}
          </CoreLink>
        </div>
      )}

      {telephone && (
        <div className="NodePartner__telephone">
          <CoreLink to={`tel:${telephone}`}>
            <i className="icon icon-arrow" />
            {telephone}
          </CoreLink>
        </div>
      )}

      {linkUrl && (
        <div className="NodePartner__link">
          <CoreLink to={linkUrl}>
            <i className="icon icon-arrow" />
            <span className="NodePartner__link-text">{linkTitle || linkUrl}</span>
          </CoreLink>
        </div>
      )}
    </div>
  );
};

export default NodePartner;
